<template>
  <div class="header wow fadeInUp">
    <div class="header_menu" v-if="$route.name!='User'">
      <div class="inner height">
        <div class="logo_box">
          <div @click="gohome" class="logo" style="cursor: pointer;">
            <img src="@/assets/logo.png" alt="" />
          </div>
          <div class="logo_text">
            <img src="@/assets/logo_text.png" alt="" />
          </div>
        </div>
        <!-- <div class="welcome">欢迎来到北京中盛润德！</div> -->
        <div class="login_box">
          <router-link v-if="!userinfo" to='login' class="login">
            <span>登录</span>
          </router-link>
          <span v-if="!userinfo">|</span>
          <router-link v-if="!userinfo" to='login' class="register">
            <span>注册</span>
          </router-link>
          <img :src="userinfo.avatar"
            style="width:26px;height:26px;border-radius: 50%;margin-right:5px;margin-left:10px" alt="" v-if="userinfo">
          <a href="javascript:;" v-if="userinfo" @click="goUser" style="position: relative;top:4px;">个人中心{{path}}</a>
        </div>
      </div>
    </div>
    <div class="header_menu header_menu-1" v-if="$route.name=='User'">
      <div class="inner">
        <div class="logo_box">
          <div @click="gohome" class="logo" style="cursor: pointer;">
            <img src="@/assets/logo.png" alt="" />
          </div>
          <div class="logo_text">
            <img src="@/assets/logo_text.png" alt="" />
          </div>
        </div>
        <div class="userInfo">
          <div class="text-1">
            您好，
            <span>{{userinfo.user_nickname}}</span>
            <span class="login-out" @click="loginOut">退出</span>
          </div>
          <!-- <div class="link">
            <div class="item">我的订单</div>
            <div class="item">选购课程</div>
            <div class="item">微信</div>
          </div> -->
          <!-- <div>帮助</div> -->
        </div>
        <div class="tip">
          人工咨询在线时间：<span>9:00-21:00</span>
        </div>
      </div>
    </div>
    <div class="header_menu" v-else>
      <div class="inner">
        <!-- <div class="logo_box">
          <div @click="gohome" class="logo" style="cursor: pointer;">
            <img src="@/assets/logo.png" alt="" />
          </div>
          <div class="logo_text">
            <img src="@/assets/logo_text.png" alt="" />
          </div>
        </div> -->
        <div :class="['menu_box',mobile ? 'mobile' : '']" @click="mobile=false">
          <div class="menu_list" @click.stop="">
            <div :class="['item',item.active || navId==item.id ? 'active' : '']" v-for="(item,index) in linkList"
              :key="item.id" @click="change(linkList,item,index)">
              <!-- <router-link :to="item.url" :target="item.id==2?'_blank':''">{{item.name}}</router-link> -->
              <router-link :to="item.url" >{{item.name}}</router-link>
            </div>
          </div>
        </div>
        <div class="mobile_btn" @click="mobile=true">
          <i class="iconfont iconenabled"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navBar',
  inject: ['reload'],

  data () {
    return {
      path: '',
      searchBox: false,
      userinfo: '',
      navId: 1,
      text: '',
      mobile: false,
      routeName: '',
      linkList: [{
        id: 1,
        name: '首页',
        routerName: 'Index',
        url: '/',
        active: false
      },
      {
        id: 2,
        name: '考研网络课',
        routerName: 'Lesson',
        url: '/lesson',
        active: false
      },
      // {
      //   id: 12,
      //   name: '考研一站式VIP',
      //   routerName: 'oneStop',
      //   url: '/oneStop',
      //   active: false
      // },
      {
        id: 13,
        name: '同等学力申硕',
        routerName: 'shenShuo',
        url: '/shenShuo',
        active: false
      },
        // {
        //   id: 8,
        //   name: '直播课',
        //   url: '/live',
        //   active: false
        // },
      {
        id: 9,
        name: '管理类联考',
        routerName: 'unitedExam',
        url: '/unitedExam',
        active: false
      },
      {
        id: 11,
        name: '圆梦复试班',
        routerName: 'dreamClass',
        url: '/dreamClass',
        active: false
      },
      {
        id: 3,
        routerName: 'Free',
        name: '免费试听课',
        url: '/free',
        active: false
      },
      {
        id: 10,
        routerName: 'Teachers',
        name: '讲师风采',
        url: '/teacher',
        active: false
      }
        // {
        //   id: 4,
        //   name: '了解考研',
        //   url: '/learn',
        //   active: false
        // },
        // {
        //   id: 5,
        //   name: '中盛资讯',
        //   url: '/info',
        //   active: false
        // },
        // {
        //   id: 6,
        //   name: '关于中盛',
        //   url: '/concerning',
        //   active: false
        // }
      ]
    }
  },

  mounted () {
    this.getinfo()
    this.navId = sessionStorage.getItem('navId')
    // this.routeName = this.
  },
  methods: {
    gohome () {
      this.$router.push({
        path: '/'
      })
      sessionStorage.setItem('navId', 1)
      this.reload()
    },
    getinfo () {
      if (localStorage.getItem('userinfo')) {
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
        // console.log(this.userinfo)
      }
    },
    change (list, item, index) {
      // eslint-disable-next-line no-return-assign
      list.forEach((e, i) => i === index ? e.active = true : e.active = false)
      this.navId = item.id
      sessionStorage.setItem('navId', item.id)
      this.mobile = false
    },
    goUser () {
      if (!this.$route.path.includes('/user')) {
        this.$router.push({
          path: '/user'
        })
        sessionStorage.setItem('navId', 7)
        this.reload()
      }
    },
    loginOut () {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userinfo')
        this.$router.push('/login')
      }).catch(() => {

      })
    }
  }
}
</script>
<style lang="scss" scoped="scoped">

.header{
      // position: sticky;
      // top: 0;
      // z-index: 1000;
    }
    .login_box{
      span{
        color: #1F86FF;
      }
    }
  @media screen and(max-width:480px) {
    .header{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      z-index: 1000;
    }
  }
  .login-out{
    color: #FF0000 !important;
    cursor: pointer;
    margin-left: 10px;
  }
  .header_menu {
    background: #fff;
    // .inner{
    //   height: 70px;
    //   padding: 0 30px;
    // }
  }

  .header_menu-1 {
    background: #fff;

    .inner {
      height: 96px;
      padding: 0 30px;
      .userInfo {
        display: flex;

        .text-1 {
          font-size: 12px;
          font-weight: 400;
          color: #000000;

          span {
            color: #4E80FF;
          }
        }

        .link {
          margin: 0 16px;
          display: flex;
          border-left: 1px solid #22222255;
          border-right: 1px solid #22222255;

          .item {
            padding: 0 13px;
            font-size: 14px;
            font-weight: 400;
            color: #222222;
          }
        }
      }

      .tip {
        font-size: 14px;
        font-weight: 400;
        color: #222222;

        span {
          color: #E72121;
        }
      }
    }
  }

  // .head{
  //   height: 40px;
  //   width: 100%;
  //      background-color: #f5f5f5;
  //   .head1{
  //     width: 1330px;
  //     height: 40px;
  //     margin:0 auto;
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     font-size: 13px;
  //     color:#676767;
  //     .right{
  //       display: flex;
  //       align-items: center;
  //       span{
  //         margin-left: 30px;
  //       }
  //     }
  //   }
  // }
  // .inner,.menu_box,.menu_list{
  //   height: 80px;
  // }
  // .inner{
  //   .logo{
  //     img{
  //       height: 46px!important;
  //     }
  //     height: 46px;
  //     width: 46px;
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/layout/components/navBar.vue